<div class="content">
	<div class="double-input">
		<ic-label (click)="onLabelClick()">
			{{ "auth.mfa_token" | translate }}
		</ic-label>
		<code-input
			#codeInput
			data-test="mfa-token-input"
			[codeLength]="6"
			[initialFocusField]="0"
			[isCodeHidden]="false"
			(codeChanged)="onCodeChanged($event)"
			(codeCompleted)="onCodeCompleted($event)"
		/>
		@if (tokenRequired) {
			<p class="errors" data-test="token-required-error">
				{{ "labels.error.required" | translate }}
			</p>
		}
		@if (toShortToken) {
			<p class="errors" data-test="token-invalid-error">
				{{ "labels.error.mfa_to_short_code" | translate }}
			</p>
		}
		<ng-content select=".message" />
	</div>
	<div class="button">
		<ui-double-button
			data-test="cancel-button-mfa"
			icon="fa fa-times"
			type="secondary"
			[disabled]="loading"
			[icValidateForms]="[form]"
			(action)="cancel()"
		>
			{{ "labels.actions.cancel" | translate }}
		</ui-double-button>
		<ui-double-button
			data-test="signin-button-mfa"
			icon="fa fa-sign-in"
			type="primary"
			[disabled]="loading"
			[icValidateForms]="[form]"
			[loading]="loading"
			(action)="validate()"
		>
			{{ "auth.signin" | translate }}
		</ui-double-button>
	</div>
</div>
